export default __webpack_public_path__ + "static/10-c5857f7de19fbc33aee7ef7688b5a86e.jpg";